module.exports = __webpack_public_path__ + "img/trustpilot.def55ff8.png";